"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.rawSendConstructor = void 0;
const isomorphic_fetch_1 = __importDefault(require("isomorphic-fetch"));
const create_error_1 = require("../create-error");
const error_interfaces_1 = require("../types/error.interfaces");
const time_management_1 = require("./time-management");
const rawSendConstructor = (globalContext, configuration) => async (request) => rawSend(request, globalContext, configuration);
exports.rawSendConstructor = rawSendConstructor;
/**
 * Simple HTTP sender with timeouts and cancellation support.
 */
const rawSend = ({ url, method, body, headers, credentials, timeout, signal, }, globalContext, configuration) => {
    if (signal?.aborted) {
        // request is aleady cancelled - do not fetch, reject immediately
        throw (0, create_error_1.createError)(error_interfaces_1.ErrorReason.RequestCancelled);
    }
    const fetchPromiseWithTimeout = (0, time_management_1.timed)((0, isomorphic_fetch_1.default)(url, {
        method,
        headers: headers && new Headers(headers),
        body,
        signal,
        credentials,
    }), globalContext, timeout ?? configuration.defaultRequestTimeoutInMs);
    return fetchPromiseWithTimeout.then((response) => {
        const headers = {};
        response.headers?.forEach((value, name) => (headers[name] = value));
        return {
            status: response.status,
            headers,
            body: response,
            url: response.url,
        };
    });
};
